module.exports = __webpack_public_path__ + "static/media/the-extra-publisher-logo-60px-high.c54bda44.png";